"use client";
import Link from "next/link";
import EkomLogo from "@/components/logo";
import { BackgroundGradientAnimation } from "@/components/ui/background-gradient-animation";

export default function Custom500() {
  // No use translations for now because the error files are out of the i18n scope
  return (
    <BackgroundGradientAnimation className="h-full">
      <div className="relative z-10 min-h-full flex items-center justify-center p-4 md:p-6">
        <div className="flex-1 flex items-center justify-center p-6 md:p-8 md:w-1/2 overflow-y-auto">
          <div className="w-full max-w-sm md:max-w-md justify-center text-center">
            <div className="mb-8 md:mb-10 flex text-center justify-center gap-10 flex-col">
              <h1 className="text-9xl">500</h1>
              <h1>Something went wrong</h1>

              <p className="text-muted-foreground text-sm md:text-base text-center">
                Our AI is working hard to fix the issue
              </p>
            </div>
            <div className="mt-6 md:mt-8 text-center z-20">
              <span className="text-sm text-muted-foreground"></span>
              <Link
                href="/"
                className="text-sm text-primary hover:underline font-semibold"
              >
                Go to home
              </Link>
            </div>
          </div>
          <div className="absolute opacity-[1%] -z-10">
            <EkomLogo size={900} />
          </div>
        </div>
      </div>
    </BackgroundGradientAnimation>
  );
}
